import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { roleLandingPath } from '../utils/appRoles';

// Landing page for the Birey OAuth return. The Digipo backend redirects here with
// the freshly-minted Digipo JWT in the URL fragment (#token=…) on success, or
// #error=… on failure. We stash the token, load the profile, and route by role.
const AuthCallback: React.FC = () => {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke guard
    ran.current = true;

    const frag = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const token = frag.get('token');
    const error = frag.get('error');
    const ad = frag.get('ad');
    // Scrub the token out of the URL immediately (history / bookmarks / referrer).
    window.history.replaceState(null, '', window.location.pathname);

    (async () => {
      if (token) {
        const role = await loginWithToken(token);
        // A token that verified but carries a role this app has no subtree for
        // (e.g. 'advisor') is not an auth failure — saying so sends the person
        // round the login loop. roleLandingPath routes it to a real message.
        navigate(role ? roleLandingPath(role) : '/login?birey_error=auth_failed', { replace: true });
      } else if (error === 'no_entitlement') {
        // Authenticated, but the kurum has no Digipo → dedicated no-access screen.
        navigate(`/erisim-yok${ad ? `?ad=${encodeURIComponent(ad)}` : ''}`, { replace: true });
      } else {
        navigate(`/login${error ? `?birey_error=${encodeURIComponent(error)}` : ''}`, { replace: true });
      }
    })();
  }, [loginWithToken, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#fafafa] gap-4">
      <div className="w-10 h-10 border-[3px] border-[#7bb51d] border-t-transparent rounded-full animate-spin" />
      <p className="text-[#20302a] text-[15px] font-semibold">Birey ile giriş yapılıyor…</p>
    </div>
  );
};

export default AuthCallback;
